/**
 * 柱状图 model 解析
 *
 * ! 这里所做的事情应该仅仅是配置项的解析计算
 * - 场景：将一系列复杂的配置项抽象为一个扩展配置项提供给业务方，在这里将该扩展配置项解析为对应的多个 echarts 配置项
 */
import type StandardChart from '../../core/StandardChart';
import type { Option } from '../../core/option';

function parse(option: Option, index: number, chart: StandardChart) {
  const barSeries = (Array.isArray(option.series) ? option.series : [option.series]).filter(
    item => item.type === 'bar'
  );
  if (barSeries.length === 0) {
    // eslint-disable-next-line no-useless-return
    return;
  }
}

export default {
  type: 'bar',
  parse
};
